import React from 'react';
import { Box, Chip, Typography, Grid } from '@mui/material';
import { Place as PlaceIcon, History as HistoryIcon } from '@mui/icons-material';
import { SAVED_SHIPPERS, SAVED_CONSIGNEES, AISavedLocation } from '../../services/aiService';

interface SavedLocationsProps {
  type: 'shipper' | 'consignee';
  onSelect: (location: AISavedLocation) => void;
  selectedId?: string;
}

export default function SavedLocations({ type, onSelect, selectedId }: SavedLocationsProps) {
  const locations = type === 'shipper' ? SAVED_SHIPPERS : SAVED_CONSIGNEES;

  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        fontWeight="500"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          mb: 1,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          fontSize: '10px',
        }}
      >
        <HistoryIcon sx={{ fontSize: 12 }} /> Saved {type === 'shipper' ? 'Shippers' : 'Consignees'} Quick-Select
      </Typography>
      <Grid container spacing={1}>
        {locations.map(loc => {
          const isSelected = selectedId === loc.id;
          return (
            <Grid item key={loc.id}>
              <Chip
                icon={<PlaceIcon sx={{ fontSize: 14 }} />}
                label={`${loc.city} (${loc.name.split(' ')[0]})`}
                onClick={() => onSelect(loc)}
                variant={isSelected ? 'filled' : 'outlined'}
                color={isSelected ? 'primary' : 'default'}
                size="small"
                sx={{
                  borderRadius: '8px',
                  fontSize: '11px',
                  fontWeight: '500',
                  height: '24px',
                  borderColor: isSelected ? 'primary.main' : '#E0E0E0',
                  backgroundColor: isSelected ? 'primary.light' : 'transparent',
                  color: isSelected ? 'primary.contrastText' : 'text.primary',
                  '&:hover': {
                    backgroundColor: isSelected ? 'primary.light' : '#F5F5F5',
                    borderColor: 'primary.main',
                  },
                }}
              />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
